/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useEffect, useState } from "react";
import ItemService from "../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import ConstantsList from "../../common/SupplierConstants";
import CustomerConstantsList from "../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../common/Validations";
import { InputField } from "../../Components/formElements/InputField";
import SupplierConstants from "../../common/SupplierConstants";
import SuccessModal from "../../Components/Modal/supplier_app/SuccessModal";
// import { appConfigFunc } from "../../redux/feature/appSlice";
import SupplierConstantsList from "../../common/SupplierConstants";

//Redux
import { useSelector } from "react-redux";
import HRConstants from "../../common/HRConstants";

const Login = () => {
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  // let [email, setEmail] = useState("");
  let [forgotEmail, setForgotEmail] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [button, setButton] = useState(true);

  const [formInputs, setFormInputs] = useState({
    email: "",
    password: "",
  });

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");

  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleCatlog = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      navigate(SupplierConstants.MATERIAL_CATLOG_SHOWPWISE_V1);
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  // USER LOGIN
  // const handleLogin = () => {
  //   // event.preventDefault();
  //   const toastId = toast.loading("Loading...", {
  //     position: "top-right",
  //   });

  //   console.log(">> formInputs", formInputs);

  //   let obj = {
  //     email: formInputs.email,
  //     password: formInputs.password,
  //   };

  //   if (formInputs.email === "" || formInputs.password === "") {
  //     toast.error("Email and Password not be Empty !!", {
  //       duration: 3000,
  //       position: "top-right",
  //     });
  //   } else {
  //     ItemService.login(obj).then((item) => {
  //       // console.log(">> item >>", item);
  //       if (item?.status === 200) {
  //         toast.success(item?.message || "User registered successfully", {
  //           duration: 2000,
  //           position: "top-right",
  //         });
  //         if (item?.data?.defaultAppCode === "ALL") {
  //           window.location = ConstantsList.APP_HOME;
  //         } else if (item?.data?.defaultAppCode === "CUSTOMER") {
  //           window.location = CustomerConstantsList.HOME_INTRO;
  //         } else {
  //           window.location = ConstantsList.HOME_INTRO;
  //         }
  //       } else {
  //         toast.error(item?.message || "Invalid input", {
  //           duration: 4000,
  //           position: "top-right",
  //         });
  //       }
  //     });
  //   }

  //   toast.dismiss(toastId);
  // };
  const handleLogin = () => {
    if (formInputs.email === "" || formInputs.password === "") {
      toast.error("Email and Password should not be empty !!", {
        duration: 3000,
        position: "top-right",
        style: {
          zIndex: 999999,
          marginTop: "70px",
        },
      });
      return;
    }

    // Loading Toast
    const toastId = toast.loading("Loading...", {
      position: "top-right",
      style: {
        zIndex: 999999,
        marginTop: "70px",
      },
    });

    console.log(">> formInputs", formInputs);

    let obj = {
      email: formInputs.email,
      password: formInputs.password,
    };

    ItemService.login(obj)
      .then((item) => {
        toast.dismiss(toastId);

        console.log(">> item >>", item);

        if (item?.status === 200) {
          toast.success(item?.message || "Login Successful", {
            duration: 3000,
            position: "top-right",
            style: {
              zIndex: 999999,
              marginTop: "70px",
            },
          });

          setTimeout(() => {
            if (item?.data?.defaultAppCode === "ALL") {
              window.location = ConstantsList.APP_HOME;
            } else if (item?.data?.defaultAppCode === "CUSTOMER") {
              window.location = CustomerConstantsList.HOME_INTRO;
            } else if (item?.data?.defaultAppCode === "HR") {
              window.location = HRConstants.HOME_INTRO;
            } else {
              window.location = ConstantsList.HOME_INTRO;
            }
          }, 1000);
        } else {
          toast.error(item?.message || "User not found !!", {
            duration: 4000,
            position: "top-right",
            style: {
              zIndex: 999999,
              marginTop: "70px",
            },
          });
        }
      })
      .catch((error) => {
        // Dismiss loader on error
        toast.dismiss(toastId);

        console.log("Login Error :", error);

        toast.error(error?.response?.data?.message || "User not found !!", {
          duration: 4000,
          position: "top-right",
          style: {
            zIndex: 999999,
            marginTop: "70px",
          },
        });
      });
  };

  const handleForgotPass = async () => {
    // await new Promise(r => setTimeout(r, 1000))
    setForgotPassword(!forgotPassword);
    setForgotEmail("");
    setSuccessMsg("");
    setErrorMsg("");
  };

  const confirmForgotPassword = async () => {
    if (validateEmail(forgotEmail)) {
      let obj = { queryName: "ValidateEmail", validate: forgotEmail };
      await ItemService.checkValidation(obj).then(async (item) => {
        // console.log(">> item", item);
        if (item.status === 200) {
          setButton(false);
          setErrorMsg("Email ID Not Found");
          setSuccessMsg("");
        } else {
          setButton(true);
          setSuccessMsg("Email ID Verified");
          setErrorMsg("");
          await new Promise((r) => setTimeout(r, 1000));
          sendMail();
        }
      });
      return;
    }

    // setForgotPassword(!forgotPassword);
  };

  const sendMail = async () => {
    let obj = { email: forgotEmail };
    await ItemService.forgotPassword(obj).then(async (item) => {
      // console.log(">> item", item);
      if (item.status === 200) {
        setErrorMsg("");
        setSuccessMsg("Mail Sent");
        successModalData.successMsg = "Mail Sent, Please check your inbox!";
        setsucceModalData(successModalData);
        setNextNavigate(SupplierConstants.LOGIN);
        onSuccessmodel();
        handleForgotPass();
      } else {
        setSuccessMsg("");
        setErrorMsg("Something went wrong !!");
      }
    });
  };

  const onInputChange = ({ target: { name, value } }) => {
    setForgotEmail(value);

    if (validateEmail(name === "forgotEmail" ? value : "")) {
      setErrorMsg("");
      setSuccessMsg("");
      setButton(false);
    } else {
      setErrorMsg("Please enter a valid email address.");
      setSuccessMsg("");
      setButton(true);
    }
  };

  const onInputChangeLogin = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const handleCheckValidation = async ({ target: { name, value } }) => {
    let obj = {};
    if (value) {
      if (validateEmail(value)) {
        obj = { queryName: "ValidateEmail", validate: value };
        await ItemService.checkValidation(obj).then((item) => {
          // console.log(">> item", item);

          if (item.status === 200) {
            setErrorMsg("Email ID Not Found");
            setSuccessMsg("");
          } else {
            setSuccessMsg("Email ID Verified");
            setErrorMsg("");
          }
        });
      }
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        // console.log("Enter key pressed!");
        handleLogin(event);
      }
    };

    // Attach event listener
    document.addEventListener("keydown", handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      window.location = "/home";
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const isEmpty = Object.keys(appConfig).length === 0;

    if (isEmpty) {
      console.log("appConfig is empty");
      // toast.error("Please configured the application !!", {
      //   duration: 10000,
      //   position: "top-center",
      // });
    } else {
      console.log("appConfig is not empty");
    }

    // eslint-disable-next-line
  }, [appConfig]);

  const handleRegister = () => {
    navigate(ConstantsList.SELF_REGISTRATION);
  };
  const handleCustomerRegister = () => {
    // navigate(CustomerConstantsList.CUSTOMER_V1_REGISTER);
    navigate(CustomerConstantsList.CUSTOMER_V1_REGISTER_LOGIN);
    // navigate(SupplierConstants.MATERIAL_CATALOG_SHOPWISE);
  };

  const appStyle = {
    backgroundImage: `url(${process.env.REACT_APP_LOGIN_BG_IMG})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top",
    height: "125vh",
    margin: "0",
    position: "relative" /* Required for positioning the overlay */,
  };

  return (
    <div className="loginBackground" style={appStyle}>
      <div className="overlay"></div>
      <div className="topHeader">
        <div className="headerLeft">
          <img
            // src={appConfig?.productLogo}
            src={"/assets/img/byyizzy.png"}
            alt="LOGO"
            className="headerLogoLeft"
          />
        </div>
        <div className="headerCenter">
          <span className="headerTitle1">
            CloudSuite – Partner Collaboration Platform
          </span>
        </div>
        <div className="headerRight">
          <button
            className="btnBack semibold d-flex align-items-center justify-content-center gap-4"
            onClick={() => navigate(SupplierConstantsList.PUBLIC_TENDOR_LIST)}
          >
            <i className="bi bi-megaphone-fill"></i>
            <span className="btn-text">Public Tender</span>
          </button>
          <button
            className="btnBack fw-semibold d-flex align-items-center justify-content-center gap-4"
            onClick={handleCatlog}
          >
            <i className="bi bi-grid"></i>
            <span className="btn-text">Product Catalog</span>
          </button>
        </div>
      </div>

      <main>
        <div className="">
          <section className="section register d-flex flex-column align-items-center justify-content-center pt-2">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-12 col-sm-12 d-flex flex-column">
                  <h1 className=" pt-sm-0 d-flex justify-content-center align-items-end">
                    {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS ===
                      "1" && (
                      <>
                        <img
                          className="img-fluid headerLogo"
                          // src={appConfig?.productLogo}
                          src={"/assets/img/byyizzy.png"}
                          alt="productLogo"
                        />
                        <div className="d-flex-column ms-2 mb-2 text-left">
                          <h1 className="m-0 title">
                            {appConfig?.productTitle}
                          </h1>
                          <p className="m-0 fs-5 ">
                            {appConfig?.productDescription}
                          </p>
                        </div>
                      </>
                    )}

                    <div className="heroText">
                      <h1 className="heroTitle">
                        {process.env.REACT_APP_LOGIN_HERO_TITLE}
                      </h1>
                      <h2 className="heroSubtitle">
                        {process.env.REACT_APP_LOGIN_HERO_SUBTITLE}
                      </h2>
                    </div>

                    {/* Right side - Catalog Button */}
                    {/* <div
                      style={{
                        position: "fixed",
                        top: "70px",
                        right: "20px",
                        zIndex: 9999,
                      }}
                    >
                      <button
                        type="button"
                        onClick={handleCatlog}
                        className="btn rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2"
                        style={{
                          backgroundColor: "#B3CFF2",
                          color: "#B3CFF2",
                          padding: "10px 24px",
                          minWidth: "220px",
                        }}
                      >
                        <i className="bi bi-grid"></i>
                        Product Catalog
                      </button>
                    </div> */}

                    {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS ===
                      "0" && (
                      <>
                        <div className="mt-6">&nbsp;</div>
                      </>
                    )}
                  </h1>
                </div>
              </div>
              <div className="row min-vh-100 align-items-center">
                {/* LEFT LOGIN */}
                <div className="col-lg-4 col-md-5 col-sm-8 ps-lg-5 d-flex flex-column innerLoginBox">
                  {!forgotPassword && (
                    <div className="card loginCard">
                      <div className="card-body">
                        <div
                          className="mb-3"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS ===
                          "1" ? (
                            <img
                              src={appConfig?.customerLogo1}
                              alt="logo"
                              className="loginLogo"
                              style={{ width: "150px" }}
                            />
                          ) : (
                            <img
                              // src={appConfig?.productLogo}
                              src={"/assets/img/byyizzy.png"}
                              alt="logo"
                              className="loginLogo"
                              style={{ width: "270px" }}
                            />
                          )}
                        </div>

                        {/* TITLE */}
                        <div className="pb-2">
                          <div className="card-title text-left">
                            {t("msg_login.msg_title1")}
                            <h6>{t("msg_login.msg_title2")}</h6>
                          </div>
                        </div>

                        {/* LOGIN FORM */}
                        <div className="row g-3 needs-validation">
                          <div className="col-12 leftAl">
                            <label className="form-label loingFont">
                              {t("msg_login.msg_username")}
                            </label>
                            <input
                              type="text"
                              name="email"
                              value={formInputs.email || ""}
                              className="form-control"
                              onChange={onInputChangeLogin}
                            />
                          </div>

                          <div className="col-12 leftAl">
                            <label className="form-label loingFont">
                              {t("msg_login.msg_password")}
                            </label>

                            <div className="forgot-pass">
                              <button
                                type="button"
                                className="form-check-label text-secondary"
                                onClick={handleForgotPass}
                              >
                                {t("msg_login.msg_password_forgot")}
                              </button>
                            </div>

                            <div className="input-group has-validation position-relative">
                              <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formInputs.password || ""}
                                className="form-control pe-5"
                                onChange={onInputChangeLogin}
                              />

                              <button
                                type="button"
                                className="eyeCss position-absolute end-0 top-50 translate-middle-y me-3"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  background: "transparent",
                                  border: "none",
                                  padding: 0,
                                  cursor: "pointer",
                                  zIndex: 5,
                                }}
                              >
                                <i
                                  className={
                                    showPassword
                                      ? "bi bi-eye-fill"
                                      : "bi bi-eye-slash-fill"
                                  }
                                ></i>
                              </button>
                            </div>
                          </div>

                          <div className="col-12 mt-4">
                            <button
                              className="supplier-login-btn"
                              onClick={handleLogin}
                            >
                              {t("msg_login.msg_login")}
                            </button>
                          </div>
                          {/* 
                          {process.env.REACT_APP_CUSTOMER_V1 === "0" ? (
                            <div className="col-12 mt-2">
                              <button
                                className="emsteel-user-login-btn"
                                onClick={handleRegister}
                              >
                                {t("msg_login.msg_self_register")}
                              </button>
                            </div>
                          ) : (
                            <div className="col-12 mt-2">
                              <button
                                className="btn btn-primary w-100"
                                onClick={handleRegister}
                              >
                                Registration
                              </button>
                            </div>
                          )} */}
                          {process.env.REACT_APP_CUSTOMER_V1 === "1" ? (
                            <div className="col-12 mt-2">
                              <button
                                className="supplier-login-btn"
                                onClick={handleRegister}
                              >
                                {t("msg_login.msg_self_register")}
                              </button>
                            </div>
                          ) : (
                            <div className="col-12 mt-2">
                              <button
                                className="supplier-login-btn"
                                style={{ maxWidth: "100%" }}
                                onClick={handleRegister}
                              >
                                Registration
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div className="d-flex justify-content-center mt-3">
                    {!forgotPassword && (
                      <div className="d-flex justify-content-center mt-3">
                        <button
                          type="button"
                          className="emsteel-user-login-btn"
                          onClick={handleRegister}
                        >
                          Registration
                        </button>
                      </div>
                    )}
                  </div> */}

                  {/* FORGOT PASSWORD */}
                  {forgotPassword && (
                    <div className="card loginCard">
                      <div className="card-body">
                        <h5 className="card-title text-left">
                          Reset your password
                        </h5>
                        <p className="subText">
                          Enter the email address associated with your account
                        </p>

                        <InputField
                          className="inputBox"
                          label="Email"
                          name="forgotEmail"
                          value={forgotEmail || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckValidation}
                          required
                          success={successMsg}
                          error={errorMsg}
                        />

                        <div className="col-12 mt-3">
                          <button
                            className="btn btn-primary w-100"
                            onClick={confirmForgotPassword}
                            disabled={button}
                          >
                            Continue
                          </button>
                        </div>

                        <div className="form-signin mt-2">
                          <a href="#" onClick={handleForgotPass}>
                            Return to sign in
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* RIGHT EMPTY SPACE */}
                <div className="col-lg-8 col-md-7 d-none d-md-block"></div>
              </div>
            </div>
            {process.env.REACT_APP_LOGIN_HEADER_TITLE_STATUS === "1" ? (
              <div className="w-100 text-end mr-3">
                <p className="copyright">{appConfig?.companyTitle}</p>
              </div>
            ) : (
              <></>
            )}
          </section>
        </div>
      </main>

      {/* Success Modal */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
    </div>
  );
};

export default Login;
